import { get, post } from './axios.js'

/**
 * 코드 그룹 서브 추가/수정/삭제 - /conf/codeGrpDtlEdit
 * @param {object} params
 * @property {string} params.cd_gr - 코드ID
 * @property {string} params.cd_id - 상세코드ID
 * @property {string} params.cd_nm - 코드명
 * @property {string} params.cd_val - 코드 상세
 * @property {string} params.sort_ord - 순번
 * @property {string} params.use_yn - 사용여부
 * @property {string} params.del_yn - 삭제여부
 * @property {string} params.reg_id - 등록자
 * @property {string} params.fmt_reg_dt - 등록일
 * @property {string} params.fmt_upd_dt - 수정일
 * @returns
 */
export async function codeGrpDtlEdit(params = {}) {
  try {
    const result = await post('/conf/codeGrpDtlEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 코드 구룹 상세 목록 조회 - /conf/codeGrpDtlList
 * @returns
 */
export async function codeGrpDtlList(params={}) {
  try {
    const result = await post('/conf/codeGrpDtlList',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}